import { defineStore } from 'pinia';

export const useViewStore = defineStore('view', {
  state: () => ({
    counter: 1,
    viewName: 'NameEntry',
    maxCount: 6,
  }),
  getters: {
    getCounter() {
      return this.counter;
    },
    getViewName() {
      return this.viewName;
    },
    getMaxCount() {
      return this.maxCount;
    },
  },
  actions: {
    update(name, counter) {
      this.counter = counter;
      this.viewName = name;
    },
  },
});
